module.exports = __webpack_public_path__ + "static/savings-wahala-a5c4c9136617d37c12cb7cd3e49e03f5.png";